import React from 'react';
import { formatNumber } from 'utils/numberUtil';
import './AnyaBarChartTooltip.css';

const AnyaBarChartTooltip = ({ active, payload, label, chartData, COLORS }) => {
    if (!active || !payload || payload.length === 0) return null;

    return (
        <div className="anya-bar-tooltip">
            {label}
            <ul className="tooltip-item-list">
                {payload.map((entry, index) => {
                    const dataPoint = chartData.find(item => item.name === label);
                    const color = dataPoint?.color || COLORS[index % COLORS.length];
                    return (
                        <li key={`item-${index}`} className="tooltip-item" style={{ color }}>
                            <span>{entry.name} : {formatNumber(entry.value)}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default AnyaBarChartTooltip;
